import { jsx as _jsx } from "react/jsx-runtime";
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
export const Default = (props)=>{
    const styles = `${props?.params?.GridParameters ?? ''} ${props?.params?.Styles ?? ''}`.trimEnd();
    const columnWidths = [
        props.params.ColumnWidth1,
        props.params.ColumnWidth2,
        props.params.ColumnWidth3,
        props.params.ColumnWidth4,
        props.params.ColumnWidth5,
        props.params.ColumnWidth6,
        props.params.ColumnWidth7,
        props.params.ColumnWidth8
    ];
    const columnStyles = [
        props.params.Styles1,
        props.params.Styles2,
        props.params.Styles3,
        props.params.Styles4,
        props.params.Styles5,
        props.params.Styles6,
        props.params.Styles7,
        props.params.Styles8
    ];
    const enabledPlaceholders = props.params.EnabledPlaceholders.split(',');
    const id = props.params.RenderingIdentifier;
    return /*#__PURE__*/ _jsx("div", {
        className: `row component column-splitter ${styles}`,
        id: id ? id : undefined,
        children: enabledPlaceholders.map((ph, index)=>{
            const phKey = `column-${ph}-{*}`;
            const phStyles = `${columnWidths[+ph - 1]} ${columnStyles[+ph - 1] ?? ''}`.trimEnd();
            return /*#__PURE__*/ _jsx("div", {
                className: phStyles,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                        name: phKey,
                        rendering: props.rendering
                    }, index)
                }, index)
            }, index);
        })
    });
};
